import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
// API
import api from "api";
// Action
import { openErrorDialog } from "redux/modules/errorDialog";
import {
  openConfirmDialog,
  closeConfirmDialog
} from "redux/modules/confirmDialog";
import { showSnackbar } from "redux/modules/snackbar";
import { openMessageDialog } from "redux/modules/messageDialog";
import {
  changeCustomerModalForm,
  closeCustomerModal,
  setCustomerModalErrors,
  changeCustomerModalSelectedLocales
} from "redux/modules/customerDetail";

// Component
import CustomerModal from "components/CustomerModal";

import history from "utils/history";
// asset data
import Attrs from "assets/data/AttributeData";

const mapStateToProps = state => ({
  customerModal: state.customerDetail.customerModal,
  allLocales: state.customerDetail.allLocales,
  title: "顧客編集",
  btnLabel: "更新",
  industries: state.customerDetail.industries
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  // フォームの変更
  changeCustomerForm: (key, value) => {
    // 従業員数の桁数を制限
    if (key === "employees" && value.length > 5) {
      return;
    }

    dispatch(changeCustomerModalForm(key, value));
  },
  // 言語の選択
  changeSelectedLocales: (value, key) => {
    if (key === "ja") {
      dispatch(openMessageDialog("日本語を外すことはできません。"));
    } else {
      dispatch(changeCustomerModalSelectedLocales(value));
    }
  },
  // 閉じる
  handleClose: () => dispatch(closeCustomerModal()),
  // 更新
  handleUpdate: customer => {
    const errors = customer.validation();
    if (errors.length > 0) {
      dispatch(setCustomerModalErrors(errors));
      return;
    }

    const params = {
      customer: customer.toJS(),
      defaultAttrs: Attrs()
    };

    const dialogData = {
      title: "確認",
      contentText: "顧客を更新します。よろしいですか？",
      btnLabel: "更新",
      handleClick: () => {
        api
          .patch(`customer_modal/${customer.id}`, params)
          .then(res => {
            dispatch(closeConfirmDialog());

            if (res.errors) {
              dispatch(setCustomerModalErrors(res.errors));
            } else {
              dispatch(closeCustomerModal());
              dispatch(showSnackbar("顧客を更新しました。"));
              ownProps.fetchCustomerDetail();
            }
          })
          .catch(error => dispatch(openErrorDialog(error)));
      }
    };

    dispatch(setCustomerModalErrors([]));
    dispatch(openConfirmDialog(dialogData));
  },
  // 削除
  handleDelete: customer => () => {
    const dialogData = {
      title: "確認",
      contentText: `「${customer.customerName}」を削除します。よろしいですか？`,
      btnLabel: "削除",
      caution: true,
      handleClick: () => {
        api
          .delete(`customer_detail/${customer.id}`)
          .then(() => {
            dispatch(closeConfirmDialog());
            dispatch(closeCustomerModal());
            dispatch(showSnackbar("顧客を削除しました。"));
            history.push("/customer_list", ownProps);
          })
          .catch(error => dispatch(openErrorDialog(error)));
      }
    };

    dispatch(setCustomerModalErrors([]));
    dispatch(openConfirmDialog(dialogData));
  }
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(CustomerModal)
);



// WEBPACK FOOTER //
// ./src/containers/CustomerDetail/CustomerInfoCard/Modal.js